import { ActionList, Caption, StrongValue } from '@if/mui'
import { CreditApplication } from '@src/types/CreditApplicationSchema'
import { Trans, useTranslation } from 'react-i18next'
import { useContractAwaitingSignature } from './ContractAwaitingSignature-hooks'
import ContractInformation from './ContractInformation'

interface Props {
  creditApp: CreditApplication
  isExpiryFeatureActive?: boolean
  isExpired?: boolean
}
const ContractAwaitingSignature = ({ creditApp, isExpiryFeatureActive = false, isExpired = false }: Props) => {
  const { t } = useTranslation()
  const actions = useContractAwaitingSignature(creditApp, isExpired)

  return (
    <>
      <ContractInformation creditApp={creditApp} isExpiryFeatureActive={isExpiryFeatureActive} />
      {isExpired && (
        <Caption>
          <Trans
            i18nKey="worksheet.contractExpiredExplanation"
            components={{
              r: <StrongValue sx={{ color: 'error.main' }} />,
              b: <strong />,
            }}
          />
        </Caption>
      )}
      <ActionList actions={actions} variant="button" menuLabel={t('viewCreditApplication.actions')} />
    </>
  )
}

export default ContractAwaitingSignature
